var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkshopOwnerInverted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_406",
    "data-name": "Rectangle 406",
    width: 13.765,
    height: 33.478,
    transform: "translate(-0.466 -0.035) rotate(0.202)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Workshop_Owner"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workshop_Owner",
    "data-name": "Workshop Owner",
    clipPath: "url(#clip-Workshop_Owner)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    transform: "translate(6.434 6.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(0 2.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M9.207,50.685l5.53.02a.579.579,0,0,0,.581-.577l.012-3.786a.579.579,0,0,0-.577-.581l-5.53-.02a.579.579,0,0,0-.581.577L8.63,50.1A.579.579,0,0,0,9.207,50.685ZM9.8,46.9l4.371.016-.008,2.628-4.371-.016Z",
    transform: "translate(-5.24 -29.624)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M17.953,28.906l-16.8-.06.027-8.5a2.4,2.4,0,0,1,.727-1.724L3.46,17.171,18,17.223l0-1.2-1.822-.008a.361.361,0,0,0,0-.092,4.871,4.871,0,1,0-9.741-.032.361.361,0,0,0,0,.092l-2.671-.012,1.606-6.59A3.316,3.316,0,0,1,8.6,6.8l9.426.032,0-1.184L8.59,5.62A4.477,4.477,0,0,0,4.23,9.1L2.486,16.419v.032L1.139,17.767a3.618,3.618,0,0,0-1.1,2.577L0,32.655a1.562,1.562,0,0,0,1.54,1.58l4.639.016A1.562,1.562,0,0,0,7.73,32.683l.008-2.629,10.212.036ZM7.6,15.915a3.71,3.71,0,1,1,7.419.028.751.751,0,0,0,.016.092L7.6,16.007ZM6.551,32.683a.39.39,0,0,1-.389.392l-4.639-.016a.39.39,0,0,1-.385-.4l.008-2.633,5.412.02Z",
    transform: "translate(0 -5.62)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y2: 30.191,
    transform: "translate(15.961 0.662)",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(19.453 3.062)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M52.029,57.856H49.237a1.148,1.148,0,0,1-1.147-1.147V48.477a1.148,1.148,0,0,1,1.147-1.147h2.793a1.148,1.148,0,0,1,1.147,1.147v8.228A1.149,1.149,0,0,1,52.029,57.856Z",
    transform: "translate(-48.09 -31.275)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M53.646,44.672H50.28v-.864a.85.85,0,0,1,.848-.848H52.8a.85.85,0,0,1,.848.848v.864Z",
    transform: "translate(-49.42 -28.848)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x1: 1.072,
    transform: "translate(2.007)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M54.184,18.51v9.607H52.79V18.51",
    transform: "translate(-50.944 -14.165)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M52.691,12l.966-.841-.966-3.37H51.3l-.966,3.37L51.3,12",
    transform: "translate(-49.45 -7.79)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(8.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M72.614,14.923a3.935,3.935,0,0,1-.251-7.133",
    transform: "translate(-70.21 -7.79)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M84.351,7.79a3.932,3.932,0,0,1-.251,7.129",
    transform: "translate(-78.644 -7.79)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M79.245,7.79v2.353a1.188,1.188,0,0,1-1.186,1.19H76.876a1.186,1.186,0,0,1-1.186-1.19V7.79",
    transform: "translate(-73.538 -7.79)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M76.324,25.944l0,17.4a1.527,1.527,0,0,0,1.528,1.528h0a1.527,1.527,0,0,0,1.528-1.528c0-4.5,0-17.4,0-17.4",
    transform: "translate(-73.92 -18.286)",
    fill: "none",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopOwnerInverted);
export default __webpack_public_path__ + "static/media/workshop-owner-inverted.81e118ff4cc5e3c9cc2a13fbf297c634.svg";
export { ForwardRef as ReactComponent };